import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
const PrivateLayout = () => {
  return (
    <div className="public-layout">
      <header>
      </header>

      <Sidebar />

      <main>
        <div className="main-content">
        <Outlet />
        </div>
      </main>

      <footer>
        {/*<p>© 2026 My App. All rights reserved.</p>*/}
      </footer>
    </div>
  );
};

export default PrivateLayout;
